/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wide_Neat_Calf_SinkInputs */

const en_wide_neat_calf_sink = /** @type {(inputs: Wide_Neat_Calf_SinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Won't receive surveys`)
};

const de_wide_neat_calf_sink = /** @type {(inputs: Wide_Neat_Calf_SinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhält keine Befragungen`)
};

/**
* | output |
* | --- |
* | "Won't receive surveys" |
*
* @param {Wide_Neat_Calf_SinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wide_neat_calf_sink = /** @type {((inputs?: Wide_Neat_Calf_SinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wide_Neat_Calf_SinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wide_neat_calf_sink(inputs)
	return de_wide_neat_calf_sink(inputs)
});